import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { RouterConfig } from '@edikk-edikk/country-frontend';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import ArrowRightSvg from '@edikk-edikk/country-layout-black-icon/src/arrow-right.svg';
import { CityForSelectType } from '#home/types';
import cityChooserCss from '#srcCssModules/city-chooser/city-chooser.module.scss';

type PropsType = {
  selectedCity: CityForSelectType|null;
};

const CardLocationCityChooseButton: FC<PropsType> = ({
  selectedCity,
}) => {
  const navigate = useNavigate();

  const handlerClick = useCallback(() => {
    if (!selectedCity) {
      return;
    }

    navigate(selectedCity.url, {
      state: {
        routerConfig: RouterConfig.initForCity(selectedCity.value),
      },
    });
  }, [navigate, selectedCity]);

  return (
    <Button variant={ButtonVariant.unstyled} onClick={handlerClick} aria-label="Go">
      <SvgIcon Component={ArrowRightSvg} additionalClassName={cityChooserCss.cityChooser__buttonIcon} />
    </Button>
  );
};

export { CardLocationCityChooseButton };
